import {nextTick} from "vue";
import {getStorage, setStorage, clrStorage, delStorage} from "@/utils/storage";
import Reouer from "@/router";

const avatar = "https://new.web.czmb.tech/static/img/avatar.3543bd4.png";

const state = {
    token: getStorage("TOKEN") || "",
    expiredTime: getStorage("EXPIREDTIME") || "",
    avatar: getStorage("AVATAR") || avatar,
    user: getStorage("USER") || "",
    userType: getStorage("USERTYPE") || "",
    staff: getStorage("STAFF") || "",
    staffName: getStorage("STAFFNAME") || "",
    departmentName: getStorage("DEPARTMENTNAME") || "",
    staffId: getStorage("STAFFDECPT") || "",
    staffType: getStorage("STAFFTYPE") || "",
    department: getStorage("DEPARTMENT") || "",
    isCollapse: getStorage("ISCOLLAPSE") ?? false,
    permissions: getStorage("NAVIGATION") || [],
    menuList: [],
    menuListAll: [],
    tabbar: getStorage("visitedViews") || {bars: [], active: ""},
    location: [],
    asyncRoutesMark: false,
    sqcList: [], // 送取车人配置列表
    rateList: [], // 折扣配置列表
    hourList: [], // 小时价配置列表
    departmentList: [], // 部门配置列表
    serviceList: [], // 增值服务配置列表
    surchangeList: [], // 附加服务配置列表
};

const getters = {
    authenticated: (state) => {
        let stu = false;
        if (state.token) {
            let now = Date.parse(new Date());
            if (now < state.expiredTime) {
                stu = true;
            }
        }
        return stu;
    },
};

const actions = {
    setRoutes: ({ commit }, list) => {
        commit("setMenu", list)
    },
    setRoutesAll: ({ commit }, list) => {
        commit("setMenuAll", list)
    },
    setSqcListAsync: ({ commit }, list) => {
        commit("setSqcList", list)
    },
    setRateListAsync: ({ commit }, list) => {
        commit("setRateList", list)
    },
    setHourListAsync: ({ commit }, list) => {
        commit("setHourList", list)
    },
    setDepartmentListAsync: ({ commit }, list) => {
        commit("setDepartmentList", list)
    },
    setServiceListAsync: ({ commit }, list) => {
        commit("setServiceList", list)
    },
    setSurchangeListAsync: ({ commit }, list) => {
        commit("setSurchangeList", list)
    },
};

const mutations = {
    setSqcList: (state, value) => {
        state.sqcList = value;
    },
    setRateList: (state, value) => {
        state.rateList = value;
    },
    setHourList: (state, value) => {
        state.hourList = value;
    },
    setDepartmentList: (state, value) => {
        state.departmentList = value;
    },
    setServiceList: (state, value) => {
        state.serviceList = value;
    },
    setSurchangeList: (state, value) => {
        state.surchangeList = value;
    },
    setToken: (state, value) => {
        state.token = "Bearer " + value;
        state.expiredTime = Date.parse(new Date()) + 604800000;
        setStorage("TOKEN", state.token);
        setStorage("EXPIREDTIME", state.expiredTime);
    },
    setMenu: (state, value) => {
        state.menuList = value;
    },
    setMenuAll: (state, value) => {
        state.menuListAll = value;
    },
    setUser: (state, value) => {
        state.user = value;
        setStorage("USER", value);
    },
    setUserType: (state, value) => {
        state.userType = value;
        setStorage("USERTYPE", value);
    },
    setStaff: (state, value) => {
        state.staff = value;
        setStorage("STAFF", value);
    },
    setStaffName: (state, value) => {
        state.staffName = value;
        setStorage("STAFFNAME", value);
    },
    setDepartmentName: (state, value) => {
        state.departmentName = value;
        setStorage("DEPARTMENTNAME", value);
    },
    setStaffId: (state, value) => {
        state.staffId = value;
        setStorage("STAFFDECPT", value);
    },
    setStaffType: (state, value) => {
        state.staffType = value;
        setStorage("STAFFTYPE", value);
    },
    setDepartment: (state, value) => {
        state.department = value;
        setStorage("DEPARTMENT", value);
    },
    // 菜单折叠标志
    setIsCollapse: (state, value) => {
        state.isCollapse = !state.isCollapse;
        setStorage('ISCOLLAPSE', state.isCollapse);
    },
    // 动态路由添加标记
    setAsyncRoutesMark: (state, value) => {
        state.asyncRoutesMark = value;
    },
    // 页面位置
    setLocation: (state, value) => {
        state.location = value;
    },
    // 标签栏添加
    addTabbar: (state, tab) => {
        let index = searchTabByName(tab.name);
        if (index > -1) {
            state.tabbar.bars[index].query = tab.query;
        } else {
            state.tabbar.bars.push(tab);
        }
        // console.log('0000',state.tabbar);
        nextTick(() => {
            state.tabbar.active = tab.name;
            setStorage("visitedViews", state.tabbar);
        });
    },
    // 标签栏切换
    changeTabbar: (state, name) => {
        const index = searchTabByName(name);
        setStorage("visitedViews", state.tabbar);
        if (index > -1) {
            console.log('111',state.tabbar.bars[index]);
            setStorage("visitedViews", state.tabbar);
            Reouer.push({path: state.tabbar.bars[index].path, query: state.tabbar.bars[index].query});
        }
    },
    // 标签栏移除
    removeTabbar: (state, name) => {
        if (state.tabbar.bars.length === 1) {
            return;
        }
        const {index, nextTab} = getRemoveTabByName(name);
        state.tabbar.bars.splice(index, 1);
        setStorage("visitedViews", state.tabbar);
        if (state.tabbar.active === name) {
            state.tabbar.active = nextTab.name;
            setStorage("visitedViews", state.tabbar);
            Reouer.push({path: nextTab.path, query: nextTab.query});
        }
    },
    // 标签栏批量移除
    removeTabbarCommand: (state, command) => {
        if (command.command === "all") {
            state.tabbar.bars = [];
            delStorage("visitedViews");
            Reouer.push("/");
        } else if (command.command === "others") {
            const nextTab = state.tabbar.bars[searchTabByName(command.name)];
            state.tabbar.bars = [];
            state.tabbar.bars.push(nextTab);
            state.tabbar.active = nextTab.name;
            setStorage("visitedViews", state.tabbar);
            Reouer.push({path: nextTab.path, query: nextTab.query});
        } else {
            const nextTab = state.tabbar.bars[searchTabByName(state.tabbar.active)];
            state.tabbar.bars = [];
            state.tabbar.bars.push(nextTab);
            state.tabbar.active = nextTab.name;
            setStorage("visitedViews", state.tabbar);
            Reouer.push({path: nextTab.path, query: nextTab.query});
        }
    },
    // 复位标签栏
    resetTabbar: (state) => {
        state.tabbar = {bars: [], active: ""};
        state.keepAlive = [];
        setStorage("visitedViews", state.tabbar);
    },
    // 清除缓存
    clearAll: (state) => {
        state.token = "";
        state.expiredTime = "";
        state.avatar = "";
        state.user = "";
        state.userType = "";
        state.staff = "";
        state.staffName = "";
        state.staffId = "";
        state.staffType = "";
        state.department = "";
        state.location = [];
        state.tabbar = {bars: [], active: ""};
        state.asyncRoutesMark = false;
        const loginType = getStorage("loginType");
        clrStorage();
        setStorage("loginType",loginType);
    },
};

// 获取标签下标位置
const searchTabByName = (name) => {
    let index = -1;
    state.tabbar.bars.forEach((item, ind) => {
        if (item.name === name) {
            index = ind;
        }
    });
    return index;
};
// 获取移除标签
const getRemoveTabByName = (name) => {
    let res = {
        index: searchTabByName(name),
        nextTab: null
    };
    if (res.index > -1) {
        let frontIndex = res.index - 1;
        let endIndex = state.tabbar.bars.length - 1;
        if (frontIndex >= 0) {
            res.nextTab = state.tabbar.bars[frontIndex];
        } else {
            res.nextTab = state.tabbar.bars[endIndex];
        }
    }
    return res;
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};